import { DialogContent as DialogContentUI, Flex, IconButton } from "@evergis/ui";
import styled from "styled-components";

export const DialogContent = styled(DialogContentUI)`
  padding-top: 2.5rem;
`;

export const ContentFlex = styled.div`
  display: flex;
  padding: 3rem 0 1.5rem;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const Dash = styled.span`
  align-self: flex-end;
  margin: 0 0.25rem 0.5rem;
`;

export const Reverse = styled(IconButton)`
  align-self: flex-end;
  margin: 0.5rem 0.25rem 0;
`;
Reverse.defaultProps = {
  kind: "inverse",
};

export const ClassificationDialogContainer = styled(Flex)`
  flex-direction: column;
  width: 100%;
  padding: 1rem 0 2.5rem;
`;

export const ClassificationAttributeContainer = styled.div`
  padding-bottom: 1.5rem;
`;

export const ClassificationDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;
